import api from './api';
import { ActivityPage, parseActivityPage } from '../utils/activityStream';

/** Aktivitäten-Tab (Marcel 2026-10-08): GET /api/activity/recent?limit&before → { items, nextBefore } (öffentlich) */
const activityService = {
  async getRecent(params: { limit?: number; before?: number | null } = {}): Promise<ActivityPage> {
    const { limit = 30, before = null } = params;
    const q = new URLSearchParams({ limit: String(limit) });
    if (before) q.set('before', String(before));
    const res = await api.get(`/api/activity/recent?${q.toString()}`);
    return parseActivityPage(res?.data);
  },
};

export default activityService;
